import { usePunditUserContext } from "@circle-react/contexts";

export const useIsVisualEmailBuilderTemplatesEnabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(currentCommunitySettings?.visual_email_builder_enabled);
};
